import React from 'react';
import {
  IonItem,
  IonLabel,
  IonInput,
  IonTextarea,
  IonButton,
} from '@ionic/react';

interface TagCreationFormProps {
  isVisible: boolean;
  tagName: string;
  tagDescription: string;
  onTagNameChange: (value: string) => void;
  onTagDescriptionChange: (value: string) => void;
  onAddTag: () => void;
  onCancel: () => void;
  tagType: 'product' | 'tag';
  isProduct?: boolean;
}

const TagCreationForm: React.FC<TagCreationFormProps> = ({
  isVisible,
  tagName,
  tagDescription,
  onTagNameChange,
  onTagDescriptionChange,
  onAddTag,
  onCancel,
  tagType,
  isProduct = false
}) => {
  if (!isVisible) return null;

  const displayType = isProduct ? 'Product' : 'Tag';
  const placeholder = `Enter ${displayType.toLowerCase()} name`;

  return (
    <div style={{ 
      marginTop: '1rem', 
      padding: '1rem', 
      backgroundColor: 'var(--ion-color-light)', 
      borderRadius: '8px' 
    }}>
      <IonItem>
        <IonLabel position="stacked">New {displayType} Name</IonLabel>
        <IonInput
          value={tagName}
          onIonInput={e => onTagNameChange(e.detail.value || '')}
          placeholder={placeholder}
        />
      </IonItem>
      
      <IonItem>
        <IonLabel position="stacked">Description (Optional)</IonLabel>
        <IonTextarea
          value={tagDescription}
          onIonInput={e => onTagDescriptionChange(e.detail.value || '')}
          placeholder={`Enter ${displayType.toLowerCase()} description`}
          rows={2}
        />
      </IonItem>
      
      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
        <IonButton
          fill="solid"
          expand="block"
          onClick={onAddTag}
          disabled={!tagName.trim()}
        >
          Add {displayType}
        </IonButton>
        <IonButton
          fill="clear"
          expand="block"
          onClick={onCancel}
        >
          Cancel
        </IonButton>
      </div>
    </div>
  );
};

export default TagCreationForm;
